import { FormikErrors } from 'formik';
import { hasNoSpecialCharacters } from 'src/helpers/validation';
import { FormAddress } from '../../types';
import { addressErrorMessages } from './error-messages';

export const validateAddressField = (
  formAddress: FormAddress,
): FormikErrors<FormAddress> | undefined => {
  const addressErrors: FormikErrors<FormAddress> = {};

  if (!formAddress?.street || !hasNoSpecialCharacters(formAddress?.street)) {
    addressErrors.street = addressErrorMessages.street;
  }

  if (!!formAddress?.building && !hasNoSpecialCharacters(formAddress?.building)) {
    addressErrors.building = addressErrorMessages.building;
  }

  if (formAddress?.suburbOptions && formAddress.suburbOptions.length === 0) {
    addressErrors.postalCode = addressErrorMessages.postalCode;
    addressErrors.suburb = addressErrorMessages.suburb.invalidPostalCode;
  } else if (!formAddress?.suburb || !hasNoSpecialCharacters(formAddress?.suburb)) {
    addressErrors.suburb = addressErrorMessages.suburb.invalidSuburb;
  }

  if (!formAddress?.city || !hasNoSpecialCharacters(formAddress?.city)) {
    addressErrors.city = addressErrorMessages.city;
  }

  if (!formAddress?.province || !formAddress?.province) {
    addressErrors.province = addressErrorMessages.province;
  }

  if (
    !formAddress?.postalCode ||
    formAddress?.postalCode.length !== 4 ||
    !/^[0-9]*$/.test(formAddress?.postalCode)
  ) {
    addressErrors.postalCode = addressErrorMessages.postalCode;
  }

  if (Object.values(addressErrors).length > 0) {
    return addressErrors;
  }
};
